export default __webpack_public_path__ + "static/BGHeader-1e185be3f9c7359888095c286094eb99.png";